import Const from "./const"
import Vue from "vue"
import VueResource from "vue-resource"
import Core from "../core"
import router from '../../src/router';
import {Message} from 'element-ui';

function Api() {
    Vue.use(VueResource);

    const apiList = {
        User: {
            logout: ['user/logout'],
            login: ['user/login', 'usernam', 'password'],
            loginByEmail: ['user/login-email', 'email', 'password'],
            loginByKey: ['user/login-key', 'key'],
            list: ['user/user-list','page','pageSize','type','is_disable','username'],
            listAdmin: ['user/list-user-afm','page', 'agent_id', 'company', 'apply_status'],
            createAdmin: ['user/create-admin','user_id','username','password','phone','email','company_id','authority_ids'],
            isDisable: ['user/is-disable','user_id'],
            delete: ['user/delete','user_id'],
            detail: ['user/detail','user_id'],
            updatePassword: ['user/update-password','user_id','password'],
            register: ['user/register','email','password','username','phone','country','province','city','county','address','company','industry','postal_code','email_rate'],
            updateAfmInfo: ['user/update-afm-info','user_id','agent_id','name','phone','country','province','city','county','address','company','industry','factory_device','email','email_rate'],
            listAgent: ['user/list-agent','page','province','city','role'],
            enable: ['user/enable','user_id'],
            createMember: ['user/create-afm-member','group_id', 'username', 'phone', 'email', 'password', 'is_enable', 'authority_ids'],
            switchUserAgent: ['user/switch-user-agent', 'agent_id', 'target_user_id'],
            applyUpdateAgent: ['user/apply-update-agent'],
            updateUserInfo:['user/update-user-info','user_id','username','phone','postal_code','province','city','county','address','company','industry','email','email_rate'],
            deleteUser: ['user/delete-user', 'user_id'],
            countNewApply: ['user/count-new-apply'],
            generateLoginKey: ['user/generate-login-key', 'user_id'],
            updateAfmMember: ['user/update-afm-member','user_id','username','phone','is_enable','email','authority_ids'],
            openApi: ['user/open-api/enable', 'user_id', 'enable'],
	        opc: ['user/opc/enable', 'user_id', 'enable'],
	        opcDetail: ['user/opc/detail', 'user_id'],
        },
        App: {
            detail: ['app/detail'],
	        detailByUserId: ['app/detail-by-user-id','user_id'],
            openOrEnd: ['app/open-or-end', 'id', 'flag', 'target_user_id'],
            resetAppSecret: ['app/reset-app-secret','id'],
            updateUrl: ['app/update-url', 'id', 'callback_url', 'event_type'],
        },

        Device: {
            saveDevice: ['device/save-device','device_id','industry','application','device_name','device_sn','asset_tag','asset_name','install_location','lubricantTube','lubricant','time_setting','imei','image','bearing_type','rpm','bearing_temperature','load','address','group_id','report_interval','longitude','latitude'],
            saveDeviceLora: ['device/save-device-lora','device_id','industry','application','device_name','device_sn','asset_tag','asset_name','install_location','lubricantTube','lubricant','time_setting','image','bearing_type','rpm','bearing_temperature','load','address','group_id', 'eui', 'addr', 'nwks_key', 'apps_key', 'report_interval','longitude','latitude'],
            getDeviceList:['device/list','page','status','province','city','keywords','application','type'],
            getDeviceDetail: ['device/detail','device_id'],
            getMapDeviceList: ['device/list-map', 'x_axis', 'y_axis', 'axis_offset'],
            save: ['device/import-device-file'],
            enable: ['device/enable','device_id'],
            unbindDevice: ['device/unbind-device', 'device_id'],
            deleteDevice: ['device/delete-device', 'device_id'],
	        resetDevice: ['device/reset-device', 'imei']
        },
	    DeviceAlarmLog: {
		    deviceAlarmLogService: ['device-alarm-log/list-by-device', 'page', 'device_id'],
		    list: ['device-alarm-log/list', 'page']
	    },
        Storage: {
            create: ['storage/create','storage_id','imei','model','batch'],
            createLora: ['storage/create-lora','storage_id','imei','addr','nwks_key', 'apps_key', 'model', 'batch'],
            delete: ['storage/delete','storage_id'],
            list: ['storage/list','page','active','batch','agent_id','imei','type'],
            download: ['storage/export-storage-device'],
            getEuiListAll: ['storage/get-lora-list', 'eui'],
            deleteLora: ['storage/delete-lora','storage_id'],
	        register: ['storage/register','storage_id'],

        },
        Agent: {
            save: ['agent/save','agent_id','name','contact_name','phone','province','city','address','skf_auth_code','email','password'],
            list: ['agent/list','page','province','city','name'],
            listAll: ['agent/list-all'],
            delete: ['agent/delete','agent_id'],
            detail: ['agent/detail','agent_id'],
            enable: ['agent/enable','agent_id']

        },
        Gateway: {
            save: ['gateway/save','id','eui','name'],
            list: ['gateway/list','eui','name','page','page_size'],
            delete: ['gateway/delete','id'],
            detail: ['gateway/detail','id'],

        },
        Config: {
            getIndustryList: ['config/get-industry-list'],
            getApplicationList: ['config/get-application-list','name'],
            getDeviceList: ['config/get-device-name-list','name'],
            getInstallListL: ['config/get-install-location-list'],
            getLubricantList: ['config/get-lubricant-list'],
            getApplicationListAll: ['config/get-application-list-all'],


        },
        File: {
            improtStorage: ['file/import-storage','file'],
            improtStorageLora: ['file/import-storage-lora','file']
        },
        Group: {
            addGroup: ['group/create-group', 'group_name', 'username', 'phone', 'email', 'password', 'is_enable','authority_ids'],
            getGroupList: ['group/list'],
            deleteGroup: ['group/delete-group', 'group_id'],
            listAll: ['group/list-all']
        },
        Action: {
            list: ['action/list','user_id','target_type','begin_time','end_time','page']
        },
        Auth: {
            authList: ['auth/auth-list']
        },
        Common: {
            emailCodeSend: ["common/email-verification-code-send",'email'],
            emailCodeCheck: ['common/email-verification-code-check', 'email', 'code' , 'password']
        }

    };

    function generateApi() {
        let API = this;
        for (let moduleKey in apiList) {

            let moduleApiList = apiList[moduleKey];
            API[moduleKey] = {};

            for (let functionName in moduleApiList) {
                let config = moduleApiList[functionName];

                API[moduleKey][functionName] = ((config) => {
                    return (...args) => {
                        return post(config, ...args)
                    };
                })(config);
            }
        }
    }

    generateApi.call(this);


    function post(api, ...args) {
        let token = Core.Data.getToken() || '';
        let url = Core.Const.NET.END_POINT;

        let body = '';

        let params = {
            token: token
        };

        let requestArr = {}
        for (let i = 1; i < api.length; i++) {
            let param = args[i - 1]
            param = param === undefined ? '' : param;
            // body += `&${api[i]}=${param}`
            requestArr[api[i]] = param
        }

        body = Object.assign(params, requestArr);

        url = `${url}/${api[0]}`;

        console.log(`${url}?${transformObjectToUrlencodedData(body)}`);

        let headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        return new Promise((resolve, reject) => {
            Vue.http.post(url, transformObjectToUrlencodedData(body), {headers: headers}).then(
                response => {
                    let body = response.body
                    if (response.data.hasOwnProperty('code') && response.data.code === Const.ERROR.ERROR_TOKEN_INVALID) {
                        Core.Data.clearAuthData()
                        router.push({path: '/login'})
                        return
                    }
                    if (body.hasOwnProperty('code') && body.code === 0) {
                        if (body.hasOwnProperty('error')) {
                            console.error(body.error)
                            handleError(body.error)
                            return reject(body.error)
                        } else {
                            return resolve(body.data)
                        }
                    }
                    handleError(body.message)
                    return reject(body)
                },
                error => {
                    handleError(error.message)
                    reject(error)
                }
            )
        })
    }

    function handleError(message = 'NET ERROR') {
        Message({type: "error", message: message});
    }

    this.transformObjectToUrlencodedData = transformObjectToUrlencodedData;

    function transformObjectToUrlencodedData(obj) {
        let p = [];
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                p.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
            }
        }
        return p.join('&');
    }

    return this;

}

export default new Api();
